import { BellOutlined, CustomerServiceOutlined, PoweroffOutlined, FileDoneOutlined, SettingFilled, UserAddOutlined, CheckCircleFilled, ReadOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Avatar, Badge, Button, Divider, Dropdown, Layout, Select, Spin, Tooltip } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../../../hooks/useFetch/useFetch';
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import Logo from '../../../components/model/logos/Logo';
import ProfileProjects from '../../../components/model/projects/ProfileProjects';
import MainMenu from '../../../layouts/main/MainMenu';
import MainHeaderPublic from './MainHeaderPublic';
import './MainHeader.scss'
import { ButtonLZ } from '../../../components/design/Buttons/ButtonLZ';
import LanguageSelector from '../../../components/model/language/Selector';
import { ROLES } from '../roles/Roles';
import { GoogleAccounts } from '../../../components/model/accounts/GoogleAccounts';
import { DrawerContext } from '../../../../store/DrawerContext/DrawerContext';
import { isProjectScopedPath } from '../../../../common/utils/headerScope';

const { Header } = Layout;

const MainHeader = () => {

	const { t } = useTranslation();
	const [projects, setProjects] = useState<any>(null);
	const [isMenuVisible, setIsMenuVisible] = useState(false);
	const [isPublic, setIsPublic] = useState(true);
	const [updateHeader, setUpdateHeader] = useState(false);
	const { project, setProject } = useAuth();
	const { releaseNotesModal, setReleaseNotesModal} = useContext(DrawerContext)
	const history = useHistory();
	const location = useLocation();
	const { logOut, profile, setProfile, projectGroup } = useAuth();
	const isProjectScope = isProjectScopedPath(location.pathname);

	useFetch(`${process.env.REACT_APP_API}/users/principal/projectNames`, {}, [], (data) => { // updateHeader

		setProjects(data.map);		
		setProject(data.defaultValue);		
	});

	useFetch(`${process.env.REACT_APP_API}/users/principal/profile`, {}, [updateHeader], (data) => {

		setProfile(data);
		if ("REGISTERED" == data.status) {
			history.push('/vincular', { from: location });
			setIsPublic(true);
		} else if ("CONFIGURED" == data.status) {
			history.push('/vincular', { from: location });
			setIsPublic(true);
		} else if ("ACTIVE" == data.status) {
			setIsPublic(false);
		}
	});

	const accountOverlay = () => {		

		return (
			<div style={{ fontSize: '13px', background: 'white', width: '500px', minWidth: '300px', borderRadius: '10px', boxShadow: '0px 0px 20px -8px', margin: '8px' }}>
				<div style={{ 
					background: 'white', 
					minHeight: '80px', 
					borderRadius: '12px 12px 0px 0px', 
					display: 'flex', 
					flexDirection: 'column', 
					alignItems: 'center', 
					gap: '8px', 
					padding: '16px 12px',
					boxShadow: '0 -2px 10px rgba(0,0,0,0.05)' // Un sutil sombreado superior para darle elegancia
				}}>
					{/* NOMBRE DEL PERFIL */}
					<span style={{ 
						fontWeight: 500,
						fontSize: '15px', 
						color: '#1f1f1f',
						textAlign: 'center' 
					}}>
						{profile.name}
					</span>

					{/* EMAIL */}
					<span style={{ 
						fontSize: '14px',        // Aumentado de 13px a 14px para mayor legibilidad
						fontWeight: 700,         // Toque semi-negrita para que tenga más presencia
						color: '#1890ff',        // Azul vibrante y limpio (estilo Ant Design), o usa '#1d4ed8' si prefieres un azul más oscuro/profundo
						letterSpacing: '0.2px',  // Hace que los correos electrónicos se lean mejor
						marginTop: '-2px'        // Ajustado ligeramente el margen
					}}>
						{profile.email}
					</span>
					
					{/* ROLES */}
					<div style={{ 
						display: 'flex', 
						flexWrap: 'wrap', 
						gap: '6px', 
						justifyContent: 'center', 
						alignContent: 'center',
						width: '100%',
						maxWidth: '100%',
						boxSizing: 'border-box',
						margin: '6px 0px',
						padding: '0 4px',
					}}>                        
						{profile.roles.map((role: string, i: number) => (
							<div key={i} style={{
								color: 'steelblue',
								fontSize: '12px', 
								fontWeight: 600,
								display: 'inline-flex', 
								alignItems: 'center', 
								gap: '4px',
								background: '#f0f5ff', 
								padding: '2px 8px',
								borderRadius: '4px',
								whiteSpace: 'nowrap',
								maxWidth: '100%',
							}}>
								<CheckCircleOutlined style={{ fontSize: '11px', flexShrink: 0 }} /> 
								{ROLES[role]}
							</div>
						))}
					</div>

					{/* BOTÓN DE CIERRE DE SESIÓN */}
					<div style={{ marginTop: '4px' }}>
						<ButtonLZ shape='round' size='small' color='yellow' onClick={() => { logOut() }}>
							<PoweroffOutlined />
						</ButtonLZ>
					</div>
				</div>
				
				<>
					{/* SECCIÓN PREFERENCIAS */}										
					<div style={{ 
						background: '#f8fafc', // Un gris más moderno y limpio
						border: '.5px solid #e2e8f0', // Borde fino y sutil en lugar de negro grueso
						//borderRadius: '8px', 
						padding: '12px 16px',
						margin: '0px 0px 20px 0px', // Quitamos margen izquierdo/derecho para que alinee perfecto con el Divider
						display: 'flex', 
						alignItems: 'center', 
						justifyContent: 'space-between'
					}}>
						<span style={{ 
							fontSize: '13px', 
							fontWeight: 600, 
							color: 'slategrey' // Color de texto principal suave pero legible
						}}>
							{t('dictionary.language')}
						</span>
						<LanguageSelector />                    
					</div>                                      
					
					{/* SECCIÓN MI NEGOCIO */}
					<Divider orientation='left' style={{ color: 'black', fontSize: '14px', margin: '16px 0 12px 0' }}>
						Proyectos
					</Divider>
					
					{/* Contenedor opcional para dar estructura a los proyectos si lo necesitas */}
					<div style={{ marginBottom: '16px' }}>
						<ProfileProjects profile={profile} updateHeader={updateHeader} setUpdateHeader={setUpdateHeader} />
					</div>
					
					<Divider style={{ margin: '16px 0px 8px 0px' }} />
				</>
			</div>
		);
	}
/*
	useEffect(() => {
		const client = new Client({
			brokerURL: `${process.env.REACT_APP_NOTIFICATIONS}/ws`,
			onConnect: () => {
				client.subscribe('/topic/notifications', (message) => {
					setUpdateData((prevUpdateData) => !prevUpdateData);

				});
			},
		});

		client.activate();
	}, []);

	const { data: storesData }: any = useFetch(`${process.env.REACT_APP_API}/users/notifications/last`, {}, [updateData]);


	const updateNotifications = async () => {

		await authFetch(`${process.env.REACT_APP_API}/users/notifications`, { method: 'PATCH' }).then(() => {
			setUpdateData(!updateData);
		})
	}

	const notificationOverlay = () => {


		return (
			<div>
				<div className='accountOverlay-notifications'>
					<h5>Notificaciones</h5>
					<div>
						<div>
							{storesData ?
								<><NotificationView notification={storesData}></NotificationView></> : <Spin className='spinner' />
							}
						</div>
						<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<Link onClick={() => { setIsMenuVisibleNot(false) }} to='/notificaciones'>Ver más</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}*/

	return (
		isPublic ?
			<MainHeaderPublic />
			:
			<Header className='header'>
				<div style={{ display: 'flex', width: '100%' }}>
					<Logo style={{ display: 'inline', width: '48px', marginRight: '20px', marginLeft: '10px' }} />
					<MainMenu />
				</div>
				<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					<div className='overlays-container'>
						<Tooltip title='Release Notes'>							
							<a onClick={() => {setReleaseNotesModal(true)}}><ReadOutlined style={{ fontSize: '18px', color: 'grey' }} /></a>							
						</Tooltip>
						<Tooltip title='Soporte'>
							<a href='https://localizame.atlassian.net/servicedesk/customer/portal/1' target='blank'><CustomerServiceOutlined style={{ fontSize: '18px', color: 'grey' }} /></a>
						</Tooltip>
					</div>
									
					<div style={{margin: '0px 20px', minWidth:'350px', display:'flex', justifyContent:'space-around', alignItems: 'flex-start', gap: 8}}>
						<div className={`header-scope-select${isProjectScope ? ' header-scope-select--active' : ''}`}>
							<Select 
								value={project} 
								onChange={setProject} 
								bordered={false} 
								style={{ minWidth: '100px', textAlign: 'right', fontWeight: isProjectScope ? 700 : 500 }}>
									{
										projects && Object.keys(projects).map((project: string) => {
											return (
											<Select.Option key={project} value={project}>
												{project}
											</Select.Option>)
										})
									}
							</Select>
							<small className='header-scope-select__label'>Proyecto</small>
						</div>
						
						<GoogleAccounts/>					
					</div>					
					<Dropdown open={isMenuVisible} onOpenChange={setIsMenuVisible} overlay={accountOverlay} trigger={['click']}>
						<div onClick={() => setIsMenuVisible(true)} style={{ cursor: 'pointer' }}>
							<Avatar 
								size={40} // Puedes cambiar el tamaño en píxeles (ej. 32, 40, 48)
								style={{ 
									backgroundColor: '#1b6ef5', 
									verticalAlign: 'middle',
									fontSize: '18px',
									fontWeight: 'bold',
									color: '#ffffff' // Color de la letra
								}}
							>
								{profile.name?.charAt(0).toUpperCase()}
							</Avatar>
						</div>
					</Dropdown>
				</div>
			</Header>
	)
};

export default MainHeader;

